export const EUserStatus = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
  PENDING_INVITATION: 'pending_invitation',
  NOT_LOGGED_IN: 'not_logged_in',
  NOT_INVITED: 'not_invited',
  IMPORTED: 'imported',
  DELETED: 'deleted'
};
